import React, { useState, useEffect } from 'react';
import { Card, Row, Col, Button, Input } from 'reactstrap';
import ReactTable from 'react-table';
import FetchEmployeeOffboardingActiveWorkService from '../../../../../../../Service/OPSServices/EmployeeOffboardingService/FetchEmployeeOffboardingActiveWorkService';
import TransferEmployeeOffboardingWorkService from '../../../../../../../Service/OPSServices/EmployeeOffboardingService/TransferEmployeeOffboardingWorkService';
import TransferEmployeeOffboardingStoreRolesService from '../../../../../../../Service/OPSServices/EmployeeOffboardingService/TransferEmployeeOffboardingStoreRolesService';

const emptyWork = { tasks: [], workflows: [], tickets: [] };

const tabNames = ["tasks", "workflows", "tickets", "storeRoles"];
const tabLabels = { tasks: "Tasks", workflows: "Workflows", tickets: "Tickets", storeRoles: "Store Roles" };
const tabColumns = {
  tasks: ["Task ID", "Task", "Store", "Due Date", "Priority"],
  workflows: ["Workflow ID", "Workflow", "Store", "Current Phase", "Due Date"],
  tickets: ["Ticket ID", "Issue", "Store", "Priority", "Date"],
};
const theadProps = () => ({
  style: {
    overflowY: "hidden",
    background: "#B1FA63",
  },
});

const centerCell = (content) => (
  <div className="d-flex justify-content-center w-100">{content}</div>
);

const ReadMoreText = ({ text, maxLength = 50 }) => {
  const [expanded, setExpanded] = useState(false);
  const value = text || '';
  if (value.length <= maxLength) return <p className="m-0">{value}</p>;
  return (
    <p className="m-0" style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>
      {expanded ? value : `${value.slice(0, maxLength)}...`}
      <span className="cursor-pointer ml-1" style={{ fontSize: '12px', color: '#0d6efd' }} onClick={() => setExpanded(!expanded)}>
        {expanded ? 'Read Less' : 'Read More'}
      </span>
    </p>
  );
};

function TransferActiveWork(props) {
  const {
    token, selectedPerson, header, onBack, showInfo, showConfirm, onDeactivate, onTasksTransferred,
    tab, setTab,
    assignments, setAssignments,
    transferred, setTransferred,
    roleAssignments, setRoleAssignments,
    storeRolesTransferred, setStoreRolesTransferred,
  } = props;

  const [selectedRows, setSelectedRows] = useState([]);
  const [bulkUser, setBulkUser] = useState('');
  const [bulkRoleUser, setBulkRoleUser] = useState('');
  const [searchText, setSearchText] = useState('');
  const [workData, setWorkData] = useState(emptyWork);
  const [teamMembers, setTeamMembers] = useState([]);
  const [storeRoleRows, setStoreRoleRows] = useState([]);
  const [eligibleUsers, setEligibleUsers] = useState([]);
  const [taskIds, setTaskIds] = useState([]);
  const [ticketIds, setTicketIds] = useState([]);
  const [workflowIds, setWorkflowIds] = useState([]);
  useEffect(() => {
    if (!selectedPerson) return;
    FetchEmployeeOffboardingActiveWorkService(token, { memberId: selectedPerson.id }).then((res) => {
      if (res && res.success) {
        setTaskIds(res.tasks.map(t => t.id));
        setTicketIds(res.tickets.map(t => t.id));
        setWorkflowIds(res.workflows.map(w => w.id));
        setWorkData({
          tasks: res.tasks.map(t => t.row),
          workflows: res.workflows.map(w => w.row),
          tickets: res.tickets.map(t => t.row),
        });
        const roles = res.storeRoles || [];
        setTeamMembers(res.teamMembers || []);
        setStoreRoleRows(roles);
        setEligibleUsers(res.storeRoleEligibleUsers || []);
        if (roles.every(r => r.coveredBy)) setStoreRolesTransferred(true);
      }
    });
  }, [token, selectedPerson && selectedPerson.id]);

  const countKey = { tasks: 'taskCount', workflows: 'workflowCount', tickets: 'ticketCount' }[tab];
  const assigneeOptionsList = teamMembers.map(m => (
    <option key={m.employeeId} value={m.employeeId}>
      {countKey && m.name !== undefined ? `${m.name} Working(${m[countKey] || 0})` : m.employeeName}
    </option>
  ));

  const counts = { tasks: workData.tasks.length, workflows: workData.workflows.length, tickets: workData.tickets.length };
  const workTotal = counts.tasks + transferred.tasks + counts.workflows + transferred.workflows + counts.tickets + transferred.tickets;
  const uncoveredRoles = storeRoleRows.filter(r => !r.coveredBy);
  const roleRowsCanApply = uncoveredRoles.some(r => roleAssignments[r.id]);
  const roleRowsDoneCount = storeRolesTransferred ? storeRoleRows.length : storeRoleRows.filter(r => r.coveredBy || roleAssignments[r.id]).length;
  const progressTotal = workTotal + storeRoleRows.length;
  const progressDone = transferred.tasks + transferred.workflows + transferred.tickets + roleRowsDoneCount;
  const progressPct = progressTotal ? Math.round(progressDone / progressTotal * 100) : 100;
  const eligibleOptionsList = eligibleUsers.map(u => <option key={u.id} value={u.id}>{u.name}</option>);
  const tabAssignments = assignments[tab] || {};
  const changeTab = (t) => {
    setTab(t);
    setSelectedRows([]);
    setBulkUser('');
    setSearchText('');
  };

  const toggleAll = (checked, targetIndices) => {
    const targets = targetIndices !== undefined ? targetIndices : workData[tab].map((_, i) => i);
    let next;
    if (checked) {
      next = Array.from(new Set([...selectedRows, ...targets]));
    } else {
      next = selectedRows.filter(i => !targets.includes(i));
    }
    setSelectedRows(next);
    if (checked) {
      const assigned = next.map(i => tabAssignments[i]).filter(Boolean);
      setBulkUser(assigned.length === next.length && new Set(assigned).size === 1 ? assigned[0] : '');
    } else {
      setBulkUser('');
    }
  };

  const toggleRow = (i) => {
    setSelectedRows(prev => prev.includes(i) ? prev.filter(x => x !== i) : [...prev, i]);
  };

  const stageOne = (i, user) => {
    setAssignments(prev => {
      const current = { ...(prev[tab] || {}) };
      if (user) current[i] = user; else delete current[i];
      return { ...prev, [tab]: current };
    });
  };

  const prepareBulkAssignee = (user) => {
    if (!user) {
      setBulkUser('');
      setAssignments(prev => {
        const current = { ...(prev[tab] || {}) };
        selectedRows.forEach(i => { delete current[i]; });
        return { ...prev, [tab]: current };
      });
      return;
    }
    if (!selectedRows.length) {
      setBulkUser('');
      showInfo("Select Work Items", <p>Please select the items you want to assign, or use <b>Select All</b> for every item in this tab.</p>);
      return;
    }
    setBulkUser(user);
    setAssignments(prev => {
      const current = { ...(prev[tab] || {}) };
      selectedRows.forEach(i => { current[i] = user; });
      return { ...prev, [tab]: current };
    });
  };

  const transferCurrentTab = () => {
    const total = workData[tab].length;
    const pendingIdx = workData[tab].map((_, i) => i).filter(i => tabAssignments[i]);
    const pending = pendingIdx.length;
    const label = tabLabels[tab];
    if (!pending) {
      showInfo(`Cannot Transfer ${label}`, (
        <p>Select a <b>Transfer To</b> assignee for at least one item, then click <b>Transfer {label}</b>.</p>
      ));
      return;
    }
    const currentTab = tab;
    showConfirm(`Confirm ${label} Transfer`, (
      <>
        <p>You are about to transfer <b>{pending === total ? 'all ' : ''}{pending} {label.toLowerCase()}</b> from <b>{selectedPerson.name}</b> to their selected assignees.</p>
        <p>The current assignee will be changed only after you confirm this action.</p>
      </>
    ), "Confirm Transfer", () => {
      const idState = {
        tasks: [taskIds, setTaskIds, 'taskId'],
        workflows: [workflowIds, setWorkflowIds, 'workflowId'],
        tickets: [ticketIds, setTicketIds, 'ticketId'],
      };
      const [ids, setIds, idKey] = idState[currentTab];
      const transfers = pendingIdx.map(i => ({ [idKey]: ids[i], assignedTo: tabAssignments[i] }));
      TransferEmployeeOffboardingWorkService(token, { type: currentTab, memberId: selectedPerson.id, transfers }).then((res) => {
        if (!res || !res.success) {
          showInfo("Transfer Failed", <p>{(res && res.message) || `${label} could not be transferred, please try again.`}</p>);
          return;
        }
        const done = new Set(res.transferredIds || []);
        const keepIdx = ids.map((_, i) => i).filter(i => !done.has(ids[i]));
        const remainingAssignments = {};
        keepIdx.forEach((oldIdx, newIdx) => {
          if (tabAssignments[oldIdx]) remainingAssignments[newIdx] = tabAssignments[oldIdx];
        });
        setIds(keepIdx.map(i => ids[i]));
        setWorkData(prev => ({ ...prev, [currentTab]: keepIdx.map(i => prev[currentTab][i]) }));
        setAssignments(prev => ({ ...prev, [currentTab]: remainingAssignments }));
        setTransferred(prev => ({ ...prev, [currentTab]: prev[currentTab] + (ids.length - keepIdx.length) }));
        setSelectedRows([]);
        setBulkUser('');
        if (!keepIdx.length) {
          const nextTabs = tabNames.slice(tabNames.indexOf(currentTab) + 1);
          setTab(nextTabs.find(t => t !== 'storeRoles' && counts[t] > 0) || 'storeRoles');
        }
        if (onTasksTransferred) onTasksTransferred();
      });
    });
  };

  const stageRole = (id, user) => {
    setStoreRolesTransferred(false);
    const next = { ...roleAssignments };
    if (user) next[id] = user; else delete next[id];
    setRoleAssignments(next);
    const values = uncoveredRoles.map(r => next[r.id] || '');
    setBulkRoleUser(values.every(Boolean) && new Set(values).size === 1 ? values[0] : '');
  };

  const changeBulkRoleUser = (user) => {
    setBulkRoleUser(user);
    if (user) return;
    setStoreRolesTransferred(false);
    setRoleAssignments(prev => {
      const next = { ...prev };
      uncoveredRoles.forEach(r => { delete next[r.id]; });
      return next;
    });
  };

  const assignAllStoreRoles = () => {
    if (!bulkRoleUser) {
      showInfo("Select a User", <p>Please select a user to assign to all uncovered store roles.</p>);
      return;
    }
    setStoreRolesTransferred(false);
    setRoleAssignments(prev => {
      const next = { ...prev };
      uncoveredRoles.forEach(r => { if (!next[r.id]) next[r.id] = bulkRoleUser; });
      return next;
    });
  };

  const transferStoreRoles = () => {
    showConfirm("Confirm Store Role Updates", (
      <>
        <p>Apply the store-role updates for <b>{selectedPerson.name}</b>?</p>
        <p>Existing role coverage will remain unchanged. Uncovered roles will be mapped to the selected eligible users.</p>
      </>
    ), "Confirm Updates", () => {
      const transfers = uncoveredRoles.filter(r => roleAssignments[r.id]).map(r => ({ storeId: r.storeId, roleId: r.roleId, assignedTo: roleAssignments[r.id] }));
      if (!transfers.length) {
        setStoreRolesTransferred(true);
        return;
      }
      TransferEmployeeOffboardingStoreRolesService(token, { memberId: selectedPerson.id, transfers }).then((res) => {
        if (!res || !res.success) {
          showInfo("Store Role Update Failed", <p>{(res && res.message) || 'Store roles could not be updated, please try again.'}</p>);
          return;
        }
        const nameById = Object.fromEntries(eligibleUsers.map(u => [String(u.id), u.name]));
        const done = new Set(res.transferredIds || []);
        const nextRows = storeRoleRows.map(r => done.has(r.id) ? { ...r, coveredBy: nameById[String(roleAssignments[r.id])] || '' } : r);
        setStoreRoleRows(nextRows);
        setStoreRolesTransferred(nextRows.every(r => r.coveredBy));
      });
    });
  };

  const showDeactivate = () => {
    showConfirm("Deactivate Employee", (
      <>
        <p>Are you sure you want to deactivate <b>{selectedPerson.name}</b>?</p>
        <p>
          ✓ All Tasks not signed off have been reassigned<br />
          ✓ All Workflows not signed off have been reassigned<br />
          ✓ All Tickets not closed have been reassigned<br />
          ✓ Store-role mappings reviewed and updated
        </p>
        <p>After deactivation, the user will no longer be able to log in or appear as an available assignee. Historical records will remain preserved.</p>
      </>
    ), "Deactivate Employee", onDeactivate, true);
  };

  const storeRoleColumns = [
    {
      Header: 'Store',
      accessor: 'store',
      Cell: (cellInfo) => centerCell(<p className="m-0 eo-name">{cellInfo.value}</p>),
    },
    {
      Header: 'Role to Transfer',
      accessor: 'role',
      Cell: (cellInfo) => centerCell(<p className="m-0">{cellInfo.value}</p>),
    },
    {
      Header: 'Current Mapping',
      id: 'currentMapping',
      accessor: () => selectedPerson ? selectedPerson.name : '',
      sortable: false,
      Cell: (cellInfo) => centerCell(<p className="m-0">{cellInfo.value}</p>),
    },
    {
      Header: 'Transfer To',
      id: 'transferTo',
      accessor: 'id',
      sortable: false,
      Cell: (cellInfo) => {
        const r = cellInfo.original;
        if (r.coveredBy) {
          return centerCell(<span className='eo-pill eo-pill-green'>Already covered by {r.coveredBy}</span>);
        }
        return centerCell(
          <select className='form-control eo-select' value={roleAssignments[r.id] || ''} onChange={(e) => stageRole(r.id, e.target.value)}>
            <option value=''>Select user</option>
            {eligibleOptionsList}
          </select>
        );
      },
    },
  ];

  const workColumns = tab === 'storeRoles' ? [] : [
    {
      Header: '',
      id: 'select',
      accessor: 'idx',
      sortable: false,
      width: 45,
      Cell: (cellInfo) => centerCell(
        <input type='checkbox' checked={selectedRows.includes(cellInfo.value)} onChange={() => toggleRow(cellInfo.value)} />
      ),
    },
    ...tabColumns[tab].map((h, j) => ({
      Header: h,
      id: `col${j}`,
      accessor: (d) => d.row[j],
      Cell: (cellInfo) => centerCell(j === 1
        ? <ReadMoreText text={cellInfo.value} />
        : <p className={`m-0 ${j === 0 ? 'eo-name' : ''}`}>{cellInfo.value}</p>),
    })),
    {
      Header: 'Current Assignee',
      id: 'currentAssignee',
      accessor: () => selectedPerson ? selectedPerson.name : '',
      sortable: false,
      Cell: (cellInfo) => centerCell(<p className="m-0">{cellInfo.value}</p>),
    },
    {
      Header: 'Transfer To',
      id: 'transferTo',
      accessor: 'idx',
      sortable: false,
      minWidth: 150,
      Cell: (cellInfo) => (
        <div className="d-flex justify-content-start w-100">
          <select className='form-control eo-select' value={tabAssignments[cellInfo.value] || ''} onChange={(e) => stageOne(cellInfo.value, e.target.value)}>
            <option value=''>-- Assigned To --</option>
            {assigneeOptionsList}
          </select>
        </div>
      ),
    },
  ];

  const renderStoreRoles = () => {
    const filteredStoreRoleRows = searchText.trim()
      ? storeRoleRows.filter(r => {
        const q = searchText.toLowerCase();
        return (
          String(r.store || '').toLowerCase().includes(q) ||
          String(r.role || '').toLowerCase().includes(q) ||
          String(r.coveredBy || '').toLowerCase().includes(q) ||
          (selectedPerson && String(selectedPerson.name || '').toLowerCase().includes(q))
        );
      })
      : storeRoleRows;

    return (
      <>
        <div className='eo-bulk-role-panel'>
          <Row className='w-100 align-items-center m-0'>
            <Col md={6} className='p-0 mb-2 mb-md-0'>
              <div className='eo-bulk-role-copy'>
                <strong className='mb-0'>Bulk assign uncovered store roles</strong>
              </div>
            </Col>
            <Col md={6} className='p-0'>
              <div className='eo-bulk-role-controls justify-content-md-end'>
                <Input
                  type='text'
                  placeholder='Search store roles...'
                  className='eo-search-input'
                  value={searchText}
                  onChange={(e) => setSearchText(e.target.value)}
                />
                <select className='form-control eo-select' value={bulkRoleUser} onChange={(e) => changeBulkRoleUser(e.target.value)}>
                  <option value=''>-- Assigned To --</option>
                  {eligibleOptionsList}
                </select>
                <Button className='btn-background-color' disabled={uncoveredRoles.length === 0} onClick={assignAllStoreRoles}>Apply to all uncovered</Button>
              </div>
            </Col>
          </Row>
        </div>
        <Row>
          <Col md={12}>
            <ReactTable
              data={filteredStoreRoleRows}
              columns={storeRoleColumns}
              className="-fixed -highlight -striped"
              getTheadProps={theadProps}
              defaultPageSize={10}
              noDataText={"No Data Found."}
            />
          </Col>
        </Row>
        <div className='eo-work-toolbar eo-border-top d-flex align-items-center justify-content-between flex-nowrap py-2 w-100'>
          <span className='eo-muted'>{roleRowsDoneCount} of {storeRoleRows.length} store-role mappings covered or assigned</span>
          <Button className='btn-background-color text-nowrap ml-auto flex-shrink-0' disabled={!roleRowsCanApply} onClick={transferStoreRoles}>Apply Store Role Updates</Button>
        </div>
      </>
    );
  };

  const renderWorkTab = () => {
    const rows = workData[tab];
    const mappedRows = rows.map((row, idx) => ({ row, idx }));
    const filteredRows = searchText.trim()
      ? mappedRows.filter(({ row }) => {
        const q = searchText.toLowerCase();
        const matchRow = row.some(val => String(val || '').toLowerCase().includes(q));
        const matchAssignee = selectedPerson && selectedPerson.name && selectedPerson.name.toLowerCase().includes(q);
        return matchRow || matchAssignee;
      })
      : mappedRows;
    const allSelected = filteredRows.length > 0 && filteredRows.every(r => selectedRows.includes(r.idx));
    return (
      <>
        <div className='eo-work-toolbar d-flex align-items-center justify-content-between flex-nowrap py-2'>
          <label className='eo-select-all mb-0 d-flex align-items-center flex-shrink-0'>
            <input type='checkbox' checked={allSelected} onChange={(e) => toggleAll(e.target.checked, filteredRows.map(r => r.idx))} /> Select All
            <span className='eo-muted ml-2 text-nowrap'>{selectedRows.length} selected</span>
          </label>
          <div className='eo-actions d-flex align-items-center flex-nowrap'>
            <Input
              type='text'
              placeholder={`Search ${tabLabels[tab].toLowerCase()}...`}
              className='eo-search-input'
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
            />
            <span className='eo-muted text-nowrap'><b>Assign To :</b></span>
            <select className='form-control eo-select' value={bulkUser} onChange={(e) => prepareBulkAssignee(e.target.value)}>
              <option value=''>-- Assigned To --</option>
              {assigneeOptionsList}
            </select>
            <Button className='btn-background-color eo-transfer-btn text-nowrap' onClick={transferCurrentTab}>Transfer {tabLabels[tab]}</Button>
          </div>
        </div>
        <Row>
          <Col md={12}>
            <ReactTable
              data={filteredRows}
              columns={workColumns}
              className="-fixed -highlight -striped"
              getTheadProps={theadProps}
              defaultPageSize={10}
              noDataText={"No Data Found."}
            />
          </Col>
        </Row>
      </>
    );
  };

  return (
    <>
      {header("Transfer Active Work", null, onBack)}
      <Card className='card-of-problemarea p-3 mb-3'>
        <Row className='eo-progress-head align-items-center mb-1'>
          <Col md={6}>
            <b>Transfer Progress</b>
          </Col>
          <Col md={6} className='text-right'>
            <span>{progressDone}/{progressTotal} items transferred or covered · {progressPct}%</span>
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <div className='eo-progress'><span style={{ width: `${progressPct}%` }}></span></div>
          </Col>
        </Row>
      </Card>
      <Card className='card-of-problemarea p-3'>
        <Row className='mb-2'>
          <Col md={12}>
            <div className='d-flex flex-wrap'>
              {tabNames.map(t => (
                <h5
                  key={t}
                  className={tab === t ? 'storeHealth-report-fetch' : 'storeHealth-report-fetch1'}
                  onClick={() => changeTab(t)}
                >
                  {tabLabels[t]} ({t === 'storeRoles' ? storeRoleRows.length : counts[t]})
                </h5>
              ))}
            </div>
          </Col>
        </Row>
        {tab === 'storeRoles' ? renderStoreRoles() : renderWorkTab()}
        {tab === 'storeRoles' && (
          <Row className='eo-footer-actions eo-border-top pt-3 m-0'>
            <Col md={12} className='text-right p-0'>
              <Button color="danger" className='eo-btn-danger' disabled={roleRowsCanApply} onClick={showDeactivate}>Deactivate Employee</Button>
            </Col>
          </Row>
        )}
      </Card>
    </>
  );
}

export default TransferActiveWork;
